export default (params) => ({
  trigger: {
    name: 'banners.select_banner',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'introduction',
          'primary_location',
          'secondary_location',
          'tertiary_location',
          'spotlight',
          'primary_location_fallback',
          'secondary_location_fallback',
          'spotlight_fallback',
          'top_fallback',
          'bottom_fallback',
          'top_paid',
          'bottom_paid',
        ],
      },
    },
    event: {
      name: 'select_banner',
    },
  },
});
